<template>
    <v-dialog v-model="show" width="40vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
        <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
            <v-card-title class="text-h5 lighten-2"> {{ title }} </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="productoForm" lazy-validation>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-autocomplete label="Seleciona OP" dense outlined no-data-text="No se encontro OP"
                                    item-text="serial" return-object :items="opList" prepend-inner-icon="mdi-magnify"
                                    :search-input.sync="searchOP" v-model="op" clearable :rules="validation()">
                                    <template v-slot:item="data">
                                        <div>
                                            {{ data.item.serial }} - {{ data.item.client }}
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete label="Seleciona Entrega" dense outlined return-object
                                    no-data-text="No se encontro Entrega" prepend-inner-icon="mdi-magnify"
                                    item-text="serial" :items="deliveryList" :search-input.sync="searchDelivery"
                                    :disabled="!op" v-model="delivery" clearable :rules="validation()">
                                    <template v-slot:item="data">
                                        <div>
                                            Entrega {{ data.item.serial }}
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-combobox :items="kind" v-model="productType" item-text="name"
                                    :disabled="!op || !delivery" label="Selecciona tipo de producto" return-object dense
                                    :rules="validation()" outlined></v-combobox>
                            </v-col>

                        </v-row>
                        <v-row v-if="productType && productType.value == 'MO'">
                            <v-col cols="12" md="6">
                                <v-autocomplete v-model="identification" :search-input.sync="search"
                                    :items="identificationsFounded" :loading="loader" return-object outlined dense
                                    clearable item-text="name" no-data-text="No se ha encontrado microorganismo"
                                    label="Selecciona microorganismo" :rules="validation()"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-combobox outlined item-text="name" label="Selecciona tipo de microorganismo"
                                    return-object clearable :items="types" v-model="type" dense
                                    :rules="validation()"></v-combobox>
                            </v-col>
                            <v-col cols="12" v-if="type && type.value == 'NA'">
                                <v-text-field outlined label="Ingresa folio de cepa" dense clearable
                                    :rules="validation()" v-model="folio">

                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-combobox outlined item-text="name" label="Selecciona linea" return-object clearable
                                    :items="linesaux" :disabled="identification ? false : true" v-model="lineState"
                                    dense :rules="validation()"></v-combobox>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-combobox outlined item-text="name" label="Selecciona presentación"
                                    :disabled="lineState ? false : true" return-object clearable :items="presentations"
                                    v-model="presentation" dense :rules="validation()"></v-combobox>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="Número de piezas" dense outlined clearable v-model="qtyPoduct"
                                    :rules="validation()" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-else-if="productType && productType.value == 'KIT'">
                            <v-col cols="12" md="6">
                                <v-combobox outlined item-text="name" label="Selecciona tipo de kit" return-object
                                    clearable :items="kitTypes" v-model="kitType" dense
                                    :rules="validation()"></v-combobox>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field label="Número de piezas" dense outlined clearable v-model="qtyPoduct"
                                    :rules="validation()" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-else-if="productType && productType.value == 'F'">
                            <v-col cols="12" md="6">
                                <v-combobox outlined item-text="name" label="Selecciona presentación" return-object
                                    clearable :items="presentationsF" v-model="presentation" dense
                                    :rules="validation()"></v-combobox>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field label="Número de piezas" dense outlined clearable v-model="qtyPoduct"
                                    :rules="validation()" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn color="red" block @click="closeModal" dark>Cancelar</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" block :loading="isLoading" @click="addProduct">Agregar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";

export default {
    data: () => ({
        isLoading: false,
        title: "",
        qtyPoduct: null,
        productType: null,
        type: null,
        lineState: null,
        presentation: null,
        folio: null,
        headers: [
            {
                text: "Microorganismo",
                align: "center",
                value: "identificationName",
                sortable: false,
            },
            {
                text: "Tipo",
                align: "center",
                value: "type",
                sortable: false,
            },
            {
                text: "Linea",
                align: "center",
                value: "lineStage",
                sortable: false,
            },
            {
                text: "Presentación",
                align: "center",
                value: "presentation",
                sortable: false,
            },
            {
                text: "Piezas",
                align: "center",
                value: "qty",
                sortable: false,
            },
            { text: "Acciones", align: "center", value: "order", sortable: false },
        ],
        loader: false,
        identification: null,
        search: null,
        identificationsFounded: [],
        isLoading: false,
        search: null,
        reactivations: [],
        linesaux: [],
        lines: [
            { name: "Liquido", value: "L" },
            // { name: "Solido", value: "S" },
        ],
        linesH: [
            { name: "Solido", value: "S" },
        ],
        linesA: [{ name: "Solido", value: "S" }],
        types: [
            { name: "Nativo", value: "NA" },
            { name: "Solena", value: "SO" },
        ],
        kind: [
            { name: "Microorganismos", value: "MO" },
            { name: "Kit", value: "KIT" },
            { name: "Ag. Boost", value: "F" },
        ],
        presentations: [],
        presentationsS: [
            { name: "250 g", value: "250", units: "g" },
            { name: "500 g", value: "500", units: "g" },
            { name: "2 kg", value: "2000", units: "g" },
        ],
        presentationsL: [
            { name: "5 L", value: "5000", units: "ml" },
        ],
        presentationsF: [{ name: "5 L", value: "5000", units: "ml" }],
        // productList: [{ name: "Kit", value: "kit" }],
        kitTypes: [
            { name: "Kit Tradicional", value: "CLASSIC" },
            { name: "Kit Híbrido", value: "HYBRID" },
            { name: "Kit QPCR 1", value: "QPCR_1" },
            { name: "Kit QPCR 2", value: "QPCR_2" },
            { name: "Kit QPCR 3", value: "QPCR_3" },
            { name: "Kit QPCR 4", value: "QPCR_4" },
            { name: "Kit QPCR 5", value: "QPCR_5" },
        ],
        product: null,
        kitType: null,
        _id: null,
        user: JSON.parse(localStorage.getItem("user")),
        searchOP: null,
        searchDelivery: null,
        op: null,
        delivery: null,
        opList: [],
        deliveryList: [],
    }),
    props: {
        value: Boolean,
    },
    async created() {
        this.title = "Nuevo producto";
    },
    computed: {
        ...mapState("order", ["orderToUpdate", "deliveryToUpdate"]),
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        ...mapActions("bioactives", ["searchIdentification"]),
        ...mapActions("order", ["createProduct", "getDeliveryBySerial", "getOrderBySerial"]),
        ...mapMutations(["SET_CANCEL_TOKEN"]),
        closeModal() {
            this.show = false;
        },
        async addProduct() {
            if (this.$refs.productoForm.validate()) {
                this.isLoading = true;
                let product = null;

                if (this.productType.value == "MO") {
                    product = {
                        name: this.identification.name,
                        identification: this.identification,
                        productType: this.productType.value,
                        qty: this.qtyPoduct,
                        type: this.type,
                        line: this.lineState.value,
                        presentation: this.presentation,
                        moType: this.identification.moType,
                        folio: this.folio,
                        _id: this._id,
                    };
                } else if (this.productType.value == "KIT") {
                    product = {
                        name: this.kitType.name,
                        identification: null,
                        productType: this.productType.value,
                        qty: this.qtyPoduct,
                        type: { name: "Solena", value: "SO" },
                        line: null,
                        presentation: this.kitType,
                        moType: null,
                        _id: this._id,
                    };
                } else if (this.productType.value == "F") {
                    product = {
                        name: "Ag. Boost",
                        identification: null,
                        productType: this.productType.value,
                        qty: this.qtyPoduct,
                        type: { name: "Solena", value: "SO" },
                        line: "F",
                        presentation: this.presentation,
                        moType: null,
                        _id: this._id,
                    };
                }
                try {
                    let payload = {
                        product: product,
                        user: this.user,
                        orderId: this.op._id,
                        deliveryId: this.delivery._id,
                    };
                    let response = await this.createProduct(payload);
                    if (!response) throw response;
                    this.$swal({
                        icon: "success",
                        title: `Producto añadido`,
                        showConfirmButton: false,
                        timer: 600,
                    });
                    this.$emit("addProduct");
                } catch (error) {
                    console.log(error);
                    this.$swal({
                        icon: "error",
                        title: `Algo salio mal al actualizar producto`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
                this.isLoading = false;
            }
        },
        validation(name) {
            return requiredValidation(name);
        },
        validationMultiple(name) {
            return requiredMultiple(name);
        },
    },
    watch: {
        async search(val) {
            if (!val) return;
            else {
                this.loader = true;

                if (typeof this.cancelToken != typeof undefined) {
                    this.cancelToken.cancel("Operation canceled due to new request.");
                }

                //Save the cancel token for the current request
                this.SET_CANCEL_TOKEN(axios.CancelToken.source());

                try {
                    const response = await this.searchIdentification({
                        name: val,
                    });
                    if (response.error) throw response;

                    this.identificationsFounded = response.strains;
                } catch (e) {
                    console.log(e);
                }
                this.loader = false;
            }
        },
        identification(value) {
            if (value) {
                if (value.identificationName == "Streptomyces griseoviridis") {
                    this.linesaux = this.linesA;
                } else if (value.moType == "fungi") {
                    this.linesaux = this.linesH;
                } else if (value.moType == "bacteria") {
                    this.linesaux = this.lines;
                }
            } else {
                this.linesaux = [];
            }
        },
        lineState(value) {
            if (value) {
                if (value.value == "L") {
                    this.presentations = this.presentationsL;
                } else if (value.value == "S") {
                    this.presentations = this.presentationsS;
                }
            } else {
                this.presentations = [];
            }
        },
        async searchOP() {
            if (!this.searchOP || this.op) return
            try {
                let payload = {
                    serial: this.searchOP
                }
                let response = await this.getOrderBySerial(payload)
                this.opList = response.orders
            } catch (error) {
                console.log("searchOP", error);
            }
        },
        async searchDelivery() {
            if (!this.searchDelivery || this.delivery) return
            try {
                let payload = {
                    serial: this.searchDelivery,
                    order: this.op._id,
                }
                let response = await this.getDeliveryBySerial(payload)
                this.deliveryList = response.deliveries
            } catch (error) {
                console.log(error);
            }
        }
    },
};
</script>